import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" aria-labelledby="faq-heading" className="bg-navy-950" data-id="element-32" data-mp="1bl243ai5rafj">
      <div className="mx-auto max-w-content px-4 py-20 sm:px-6 lg:py-28" style={{
      paddingTop: "0px",
      paddingBottom: "0px"
    }} data-id="element-33" data-mp="1gjlsrio4z0bl">
        <div className="grid gap-12 lg:grid-cols-[0.8fr_1.2fr]" data-id="element-34" data-mp="24a92m9hm400s">
          <div data-id="element-35" data-mp="28ajkajeroevh">
            <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-celeste-400" data-id="element-36" data-mp="28b1c93uec6xl">
              সরল উত্তর
            </p>
            <h2 id="faq-heading" className="mt-4 font-display text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-37" data-mp="1uj4mv7k44b4w">
              সাধারণ জিজ্ঞাসা
            </h2>
          </div>

          <ul className="divide-y divide-white/10 border-y border-white/10" data-id="element-38" data-mp="2n6r3bgefva96">
            {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return <li key={faq.question} data-id="element-39" data-mp="14wbuanbzolu4" data-mpi={index}>
                  <h3 data-id="element-40" data-mp="14sxunmupmqqd">
                    <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-start justify-between gap-6 py-5 text-left transition-colors duration-200 ease-smooth hover:text-celeste-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-celeste-400" data-id="element-41" data-mp="10tytmdc3ne47">
                      <span className="font-display text-lg font-bold tracking-tight text-inherit" data-id="element-42" data-mp="1oldzuh6zyfkq">
                        {faq.question}
                      </span>
                      <PlusIcon className={`mt-1 h-5 w-5 shrink-0 text-celeste-400 transition-transform duration-200 ease-smooth ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-43" data-mp="1xiobi3nq86q6" />
                    </button>
                  </h3>
                  <div id={`faq-panel-${index}`} className="faq-panel" data-open={isOpen} data-id="element-44" data-mp="3815o0eyagkv">
                    <div data-id="element-45" data-mp="3ue2iadekdi8m">
                      <p className="max-w-2xl pb-6 pr-8 text-[15px] leading-relaxed text-white/70" data-id="element-46" data-mp="1y938nr7khny7">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}